import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  state:{
  	staff:{},
    tabs:[],
    clickTab:'',
    sta:false,
    isLoding:false,
    keywords:'',
    warehouseSta:false,  //入倉查詢狀態
    storonSta:false,  //出倉查詢狀態
    searchSte:false,  //首页查詢狀態
    customerInSte:false,  //客戶详情入倉編輯狀態
    customerOnSte:false,  //客戶详情出倉編輯狀態
    ismobilePhone:false,  //是否是手机登录
      collapsed:false,
  },

  
  mutations:{
      clearTabs(state){
          state.tabs=[];
      },
 	  updateStaff(state,staff){
       state.staff=staff;
      },
      addTab(state,tab){
		  
 	      var i=state.tabs.findIndex(item=>item.name==tab.name);
		  // console.log("add=="+tab.name);
		  //   console.log("addiii===="+i);
          if(i==-1){
            state.tabs.push(tab);
          }else{
            for(let i=0;i<state.tabs.length;i++){
              if(tab.name==state.tabs[i].name){
                  state.tabs.splice(i,1,tab);    
                  break;
              }
            }
            
          }
      },
      closeTab(state,name){
          var i=state.tabs.findIndex(item=>item.name==name);
		   console.log("jjjj==="+i);
		   console.log(state.tabs);
		   
		  state.tabs.splice(i,1);
		    console.log("jjjj===");
		   console.log(state.tabs);
         
      },
      setterClickTab(state,value){
          state.clickTab = value;
      },
      setSta(state,value){
          state.sta = value;
      },
      setKeywords(state,value){
          state.keywords = value;
      },
      setWarehouseSta(state,value){
          state.warehouseSta = value;
      },
      setStoronSta(state,value){
          state.storonSta = value;
      },
      setIsLoding(state,value){
          state.isLoding = value;
      },
      setSearchSte(state,value){
          state.searchSte = value;
      },
      setCustomerInSte(state,value){
          state.customerInSte = value;
      },
      setCustomerOnSte(state,value){
          state.customerOnSte = value;
      },
      setIsmobilePhone(state,value){
          state.ismobilePhone = value;
      },
      setCollapsed(state,value){
          state.collapsed = value;
      }


  },
  getters:{
      tabs:state=>{
          return state.tabs;
      },
  	 staff:state=>{
		  return state.staff;
  	 },
     permissions:state=>{
      return state.staff.permissions;
     },
     hasPermission:(state)=>(permission)=>{
         return state.staff.permissions.findIndex(item=>item===permission)>=0?true:false;
     },
      sta:state=>{
          return state.sta;
      },
      isLoding:state=>{
          return state.isLoding;
      },
      keywords:state=>{
          return state.keywords;
      },
      warehouseSta:state=>{
          return state.warehouseSta;
      },
      storonSta:state=>{
          return state.storonSta;
      },
      searchSte:state=>{
          return state.searchSte;
      },
      customerInSte:state=>{
          return state.customerInSte;
      },
      customerOnSte:state=>{
          return state.customerOnSte;
      },
      ismobilePhone:state=>{
          return state.ismobilePhone;
      },
      collapsed:state=>{
          return state.collapsed;
      },
     getTabs:state=>{
        return state.clickTab;
     }
  },
  actions:{

  }
})



// WEBPACK FOOTER //
// ./src/store/store.js